import { Components, Theme } from '@mui/material';

export const switchOverrides: Components<Theme>['MuiSwitch'] = {
  styleOverrides: {
    root: {
      width: 33,
      height: 20,
      padding: 0,
    },
    switchBase: {
      padding: 0,
      margin: 2,
      transitionDuration: '400ms',
      '&.Mui-checked': {
        transform: 'translateX(12px)',
        '& + .MuiSwitch-track': {
          background: (theme: Theme) => theme.palette.primary.main,
          opacity: '1 !important',
        },
      },
    },
    thumb: ({ theme }) => ({
      width: 16,
      height: 16,
      color: theme.palette.common.white,
    }),
    track: {
      borderRadius: 100,
    },
  },
};
